var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.302 44.5709C43.5559 44.5709 44.5725 43.5541 44.5725 42.3002V5.69844C44.5725 4.44408 43.5557 3.42773 42.302 3.42773H5.70039C4.44603 3.42773 3.42969 4.44423 3.42969 5.69844V42.3C3.42969 43.5541 4.44603 44.5707 5.70039 44.5707L42.302 44.5709Z",
    fill: "#485A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8209 44.5718V28.6389H37.1689L37.9695 22.4296H31.8208V18.4652C31.8208 16.6674 32.3199 15.4423 34.898 15.4423L38.186 15.4408V9.88722C37.6173 9.81169 35.6654 9.64258 33.3948 9.64258C28.6541 9.64258 25.4085 12.5362 25.4085 17.8504V22.4296H20.0469V28.6389H25.4085V44.5716L31.8209 44.5718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5c735e71b8ab29d8d4fa84f36d89526a.svg";
export { ForwardRef as ReactComponent };